export const TransactionalPushNotificationType = {
    TWO_WEEKS_AFTER_CONSULTATION_IF_NO_FOLLOWUP_APPOINTMENT_BOOKED: 'TWO_WEEKS_AFTER_CONSULTATION_IF_NO_FOLLOWUP_APPOINTMENT_BOOKED',
    ONE_DAY_AFTER_TREATMENT_PLANNER_CREATED_IF_NOT_VIEWED: 'ONE_DAY_AFTER_TREATMENT_PLANNER_CREATED_IF_NOT_VIEWED',
    AFTER_TREATMENT_FEEDBACK_REQUEST: 'AFTER_TREATMENT_FEEDBACK_REQUEST',
    CUSTOMER_BLOOD_REPORT_READY: 'CUSTOMER_BLOOD_REPORT_READY',
} as const;

export type TransactionalPushNotificationType = typeof TransactionalPushNotificationType[keyof typeof TransactionalPushNotificationType];

export function formatTransactionalPushNotificationType(type: TransactionalPushNotificationType): string {
    switch (type) {
        case TransactionalPushNotificationType.TWO_WEEKS_AFTER_CONSULTATION_IF_NO_FOLLOWUP_APPOINTMENT_BOOKED:
            return 'Two Weeks After Consultation If No Followup Appointment Booked';
        case TransactionalPushNotificationType.ONE_DAY_AFTER_TREATMENT_PLANNER_CREATED_IF_NOT_VIEWED:
            return 'One Day After Treatment Planner Was Created If Not Viewed By Customer'
        case TransactionalPushNotificationType.AFTER_TREATMENT_FEEDBACK_REQUEST:
            return 'After Treatment Feedback Request';
        case TransactionalPushNotificationType.CUSTOMER_BLOOD_REPORT_READY:
            return "Triggered when the customer's blood report is now ready";
        default:
            return type;
    }
}
